<template>
	<div class='loading-message'>
		<SpinnerOne class='spinner' />
		<h1 class='load-header'>{{header}}</h1>
		<div class='load-message'>{{message}}</div>
	</div>
</template>



<script>

import SpinnerOne from "@/components/helpers/SpinnerOne";

// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "LoadingScreen",
	components: {
		SpinnerOne
	},
	props: {
		header: {
			default: () => this.getText('LoadingHeader')
		},
		message: {
			default: () => this.getText('LoadingMessage')
		}
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		}
	}
};
</script>

<style scoped lang="scss">

</style>
